var prefixCls = 'rab-';
export default {
    alert: prefixCls + "alert",
    avatar: prefixCls + "avatar",
    backtop: prefixCls + "back-top",
    badge: prefixCls + "badge",
    breadcrumb: prefixCls + "breadcrumb",
    button: prefixCls + "btn",
    card: prefixCls + "card",
    carousel: prefixCls + "carousel",
    collapse: prefixCls + "collapse",
    divider: prefixCls + "divider",
    drawer: prefixCls + "drawer",
    dropdown: prefixCls + "dropdown",
    empty: prefixCls + "empty",
    jumbotron: prefixCls + "jumbotron",
    inputNumber: prefixCls + "input-number",
    icon: prefixCls + "icon",
    loadingBar: prefixCls + "loading-bar",
    message: prefixCls + "message",
    messageChild: prefixCls + "message-notice",
    modal: prefixCls + "modal",
    notice: prefixCls + "notice",
    pageHeader: prefixCls + "page-header",
    poptip: prefixCls + "poptip",
    noticeChild: prefixCls + "notice-notice",
    progress: prefixCls + "progress",
    radio: prefixCls + "radio",
    result: prefixCls + "result",
    skeleton: prefixCls + "skeleton",
    switch: prefixCls + "switch",
    tabs: prefixCls + "tabs",
    tag: prefixCls + "tag",
    spin: prefixCls + "spin",
    steps: prefixCls + "steps",
    time: prefixCls + "time",
    timeline: prefixCls + "timeline",
    tooltip: prefixCls + "tooltip"
};
